import { InformationIcon, SectionHeader } from "~/common/components";

export const FunctionalDomainsTitleV4 = ({ onClick }: { onClick: () => void }) => (
  <div className="flex items-center gap-2">
    <SectionHeader>
      Functional domains
    </SectionHeader>
    <button onClick={onClick}>
      <InformationIcon className="size-4 text-gray-20" />
    </button>
  </div>
);
